import React from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { Store, LogIn, UserPlus, Home, ShoppingCart } from "lucide-react";
import { MKT_GOLD } from "../../lib/marketplace";
import { useCart } from "../../context/CartContext";

const linkBase = "inline-flex items-center gap-1.5 text-sm font-semibold transition-colors";

export default function PublicMarketplaceLayout() {
  const { count } = useCart();
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="public-marketplace-layout">
      <header className="sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
          <Link to="/tienda" data-testid="public-nav-logo" className="inline-flex items-center gap-2 font-extrabold text-slate-900">
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg text-white" style={{ backgroundColor: MKT_GOLD }}>
              <Store size={18} />
            </span>
            <span className="text-lg">ConstruLink</span>
            <span className="text-xs font-bold uppercase tracking-widest px-1.5 py-0.5 rounded" style={{ color: MKT_GOLD, backgroundColor: "rgba(217,119,6,0.10)" }}>Marketplace</span>
          </Link>

          <nav className="hidden sm:flex items-center gap-6">
            <a href="/" data-testid="public-nav-inicio" className={`${linkBase} text-slate-600 hover:text-slate-900`}>
              <Home size={15} /> Inicio
            </a>
            <NavLink to="/tienda" end data-testid="public-nav-marketplace" className={({ isActive }) => `${linkBase} ${isActive ? "" : "text-slate-600 hover:text-slate-900"}`} style={({ isActive }) => (isActive ? { color: MKT_GOLD } : undefined)}>
              <Store size={15} /> Marketplace
            </NavLink>
          </nav>

          <div className="flex items-center gap-2">
            <Link to="/tienda/carrito" data-testid="public-nav-carrito" className="relative inline-flex items-center justify-center w-10 h-10 rounded-lg text-slate-700 hover:bg-slate-100">
              <ShoppingCart size={18} />
              {count > 0 && (
                <span data-testid="public-cart-count" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold text-white flex items-center justify-center" style={{ backgroundColor: MKT_GOLD }}>{count}</span>
              )}
            </Link>
            <Link to="/login" data-testid="public-nav-login" className={`${linkBase} px-3 py-2 rounded-lg text-slate-700 hover:bg-slate-100`}>
              <LogIn size={15} /> Iniciar sesión
            </Link>
            <Link to="/register" data-testid="public-nav-register" className={`${linkBase} px-3 py-2 rounded-lg text-white hover:brightness-110`} style={{ backgroundColor: MKT_GOLD }}>
              <UserPlus size={15} /> Crear cuenta
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1" data-testid="public-marketplace-main">
        <Outlet />
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-slate-400 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span>© {new Date().getFullYear()} ConstruLink · Marketplace de recursos digitales.</span>
          <nav className="flex flex-wrap items-center gap-x-4 gap-y-1 justify-center" data-testid="public-footer-legal">
            <Link to="/legal/terminos" className="hover:text-slate-700" data-testid="footer-legal-terminos">Términos</Link>
            <Link to="/legal/privacidad" className="hover:text-slate-700" data-testid="footer-legal-privacidad">Privacidad</Link>
            <Link to="/legal/reembolsos" className="hover:text-slate-700" data-testid="footer-legal-reembolsos">Reembolsos</Link>
          </nav>
          <span>Contenido publicado por vendedores independientes.</span>
        </div>
      </footer>
    </div>
  );
}
